import MainGridController from "../../controllers/grid/MainGridController";
import QuestPromptController from "../../controllers/quest/QuestPromptController";
import { COMPONENTS } from "../../lib/constants";
import { QuestPromptViewGrid } from "./QuestPromptViewGrid";

export const QuestPromptView = {
  name: COMPONENTS.QUEST_PROMPT,
  child: true,
  zIndex: 2,
  position: {
    x: 0,
    y: 0,
  },
  controllers: [
    {
      Controller: QuestPromptController,
      name: "QuestPromptController",
      config: {
        holder: "quest_prompt_holder",
      },
    },
    {
      Controller: MainGridController,
      name: "QuestPromptGridController",
      config: QuestPromptViewGrid,
    },
  ],
  components: [
    {
      name: "quest_prompt_holder",
      type: "Sprite",
      components: [
        {
          name: "bg",
          type: "Sprite",
          img: "autospin_bg",
          position: { x: 0, y: 0 },
          // alpha: 0.6,
        },
        {
          name: "bg_border",
          type: "Sprite",
          img: "sm_modal_frame",
          position: { x: -7, y: 0 },
        },
        {
          name: "header",
          type: "CustomText",
          text: "QUEST_PROMPT_HEADER",
          position: { x: 587 / 2 + 10, y: 30 },
          anchor: { x: 0.5, y: 0 },
        },
        {
          name: "QUEST_PROMPT_TITLE",
          type: "Text",
          text: "QUEST_PROMPT_TITLE",
          position: { x: 587 / 2, y: 90 },
          anchor: { x: 0.5, y: 0 },
        },
        {
          name: "QUEST_PROMPT_PRIZE",
          type: "CustomText",
          text: "QUEST_PROMPT_PRIZE",
          position: { x: 587 / 2 + 10, y: 185 },
          anchor: { x: 0.5, y: 0 },
        },
        {
          name: "QUEST_PROMPT_AMOUNT",
          type: "CustomText",
          text: "QUEST_PROMPT_AMOUNT",
          position: { x: 587 / 2 + 15, y: 260 },
          anchor: { x: 0.5, y: 0 },
        },
        {
          name: "QUEST_PROMPT_YES",
          type: "ActionButton",
          bg: "dialog_yes_btn",
          position: { x: 587 / 2, y: 395 },
        },
      ],
    },
  ],

  // DEB2BF
};
